export const FilterComponentTestSubjects = {
    Container: 'filter-container',
    ContextMenuOption: 'filter-context-menu-option',
};
//# sourceMappingURL=filter-test-subjects.enum.js.map